import React, { lazy } from 'react';
import { AuthGuard } from '@nsd/fe';
import {
  Clipboard as RegisterIcon,
  Settings as SettingsIcon,
  Users as UsersIcon
} from 'react-feather';
import TopBarAddOn from 'src/components/TopBarAddOn';
import DashboardLayout from 'src/layouts/DashboardLayout';

const appIcon =
  'https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/adminQoreAppIcon.png';
const MODULE = {
  USERS: 'users-ff88abef-ab45-4cff-b62e-4b83ac2e881c',
  COMPANIES: 'companies-8cb0bd03-9872-4625-8626-3d7822841613',
  ROLES: 'roles-a96c187c-5c95-4b86-9624-033970d3aae2',
  PACKAGES: 'packages-213196f1-8879-48f7-88d6-76b6dc24c494',
  SUITES: 'suites-d7b51bd8-1113-4c7d-b044-ea5e012b9b6b',
  COMPANY_SETTINGS: 'companySettings-bd57e050-1339-43e5-b572-ff876c4112ff',
  REGISTER_DEALERS: 'registerDealers-e996b9d4-40fb-45ab-a6f9-c58b7926d62d',
};

/* 
  Note: customerPortal-9b2c764c-2832-4519-800a-4107ff4fdd8e suite doesn't have any apps
  (As of 2/21/2022) within it so none will show up on the app menu in the topBar unless added
 */
const appConfig = {
  appId: 'admin-666dab45-6a24-4054-9e3f-588a07c481d0',
  appName: 'Admin',
  titleKey: 'admin',
  priority: 1,
  path: 'admin',
  icon: appIcon,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: 'users',
      view: lazy(() => import('src/views/Admin/UsersView/index')),
      module: MODULE.USERS
    },
    {
      exact: true,
      path: 'settings',
      view: lazy(() => import('src/views/Admin/CompanySettingsView/index'))
      // module: MODULE.COMPANY_SETTINGS
    },
    {
      exact: true,
      path: 'settings/stripe-onboard-user/refresh',
      view: lazy(() =>
        import(
          'src/views/Admin/CompanySettingsView/payee/stripe-onboarding-callback'
        )
      )
      // module: MODULE.COMPANY_SETTINGS
    },
    {
      exact: true,
      path: 'register-dealers',
      view: lazy(() => import('src/views/Admin/RegisterDealers/index')),
      module: MODULE.REGISTER_DEALERS
    },
    {
      exact: true,
      path: 'settings/stripe-onboard-user/success',
      view: lazy(() =>
        import(
          'src/views/Admin/CompanySettingsView/payee/stripe-onboarding-callback'
        )
      )
      // module: MODULE.COMPANY_SETTINGS
    }
  ],
  // Copy for all apps
  topBarConfig: {
    // dataContextOptions: PropTypes.shape({
    //   options: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       key: PropTypes.any,
    //       value: PropTypes.any,
    //       name: PropTypes.string,
    //       secondLine: PropTypes.string,
    //     })
    //   ),
    //   enableDataContextOverride: PropTypes.bool,
    //   customJSX: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    // }),
    dataContextOptions: {
      enableDataContextOverride: true,
      customJSX: <TopBarAddOn />
    },
    contacts: false,
    search: false,
    notifications: true,
    settings: true
  },
  navConfig: {
    navBarItems: [
      {
        subheader: 'Management',
        items: [
          {
            title: 'Users',
            icon: UsersIcon,
            href: 'users',
            module: MODULE.USERS
          },
          {
            title: 'Settings',
            icon: SettingsIcon,
            href: 'settings'
            //module: MODULE.COMPANY_SETTINGS
          },
          {
            title: 'Register Dealers',
            icon: RegisterIcon,
            href: 'register-dealers',
            module: MODULE.REGISTER_DEALERS
          }
        ]
      }
    ]
  }
};

export default appConfig;
